import type { NetworkPlayer } from './protocol';
import { decodePredictionState, readPredictionState } from './predictionState';

/** Pair public pose and private memory from the SAME snapshot; never retain a
 * nested capability from shared wire players or pair unrelated actor IDs. */
export function decodeRestraint(value: unknown, owner: NetworkPlayer, players: readonly NetworkPlayer[]): NetworkPlayer['restraint'] {
  if (!value || typeof value !== 'object' || !readPredictionState(owner)) return undefined;
  const data = value as Record<string, unknown>;
  if (typeof data.peerId !== 'string' || data.peerId === owner.id ||
    typeof data.remaining !== 'number' || !Number.isFinite(data.remaining) || data.remaining <= 0 || data.remaining > 1.65) return undefined;
  const publicPeer = players.find(player => player.id === data.peerId);
  const state = decodePredictionState(data.state);
  if (!publicPeer || !state || !owner.connected || owner.extracted || !publicPeer.connected || publicPeer.extracted
    || (owner.trainNumber ?? 1) !== (publicPeer.trainNumber ?? 1)) return undefined;
  if (![publicPeer.position.x, publicPeer.position.y, publicPeer.position.z,
    publicPeer.velocity.x, publicPeer.velocity.y, publicPeer.velocity.z,
    publicPeer.yaw, publicPeer.pitch].every(Number.isFinite)) return undefined;
  const paired = owner.grabbedById === publicPeer.id && publicPeer.grabTargetId === owner.id
      && !owner.grabTargetId && !publicPeer.grabbedById
    || owner.grabTargetId === publicPeer.id && publicPeer.grabbedById === owner.id
      && !owner.grabbedById && !publicPeer.grabTargetId;
  if (!paired || publicPeer.inputLeaseTicks !== undefined &&
    (!Number.isInteger(publicPeer.inputLeaseTicks) || publicPeer.inputLeaseTicks < 0 || publicPeer.inputLeaseTicks > 10)) return undefined;
  const peer = { ...publicPeer, predictionState: state, restraint: undefined, itemReceipt: undefined };
  if (!readPredictionState(peer)) return undefined;
  return { remaining: data.remaining, peer };
}
